import Cookie from 'js-cookie';
import fetchConfig, { API_HOST } from 'lib/fetchUtils';

document.querySelectorAll('#cookie-banner button').forEach(buttonElement => {
  buttonElement.addEventListener('click', e => {
    if (e.target.id === 'allow-cookies') {
      e.preventDefault();
      setCookieConsent(true);
      $('#cookie-banner').fadeOut();
    }

    if (e.target.id === 'reject-cookies') {
      e.preventDefault();
      setCookieConsent(false);
      $('#cookie-banner').fadeOut();
    }
  });
});

const cookieConsentName = 'mubi-cookie-consent';
const isAuthenticated = window.mubiState && window.mubiState.currentUserId != null;

const setCookieConsent = isConsentGiven => {
  setCookieConsentCookie(isConsentGiven);
  setCookieConsentInTagManagerDataLayer(isConsentGiven);

  if (isAuthenticated) {
    persistCookieConsentToDatabase(isConsentGiven);
  }
};

const setCookieConsentCookie = isConsentGiven => {
  Cookie.set(cookieConsentName, isConsentGiven ? 'allow' : 'reject', {
    expires: 365,
  });
};

const setCookieConsentInTagManagerDataLayer = isConsentGiven => {
  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(getConsentEvent(isConsentGiven));
  }
};

const persistCookieConsentToDatabase = isConsentGiven => {
  fetch(`${API_HOST}/api/v1/current_user`, fetchConfig('PUT', {
    cookie_consent: {
      analytics: isConsentGiven,
      marketing: isConsentGiven,
    },
  }));
};

const getConsentEvent = userConsent => ({
  event: 'cookie-consent-set',
  cookieConsent: {
    functional: true,
    analytics: userConsent,
    marketing: userConsent,
  },
});
